import { MUTATION_KEYS } from "library/shared";
import { useMutation } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

type Params = {
  countryCode: number;
  clientInternalNumberGOS: number;
};

const revokeConsents = async ({ countryCode, clientInternalNumberGOS }: Params) => {
  const response = await api.patch(
    `/employee/consents/revoke/${countryCode}/${clientInternalNumberGOS}`
  );
  return response.data;
};

export function useRevokeConsents() {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(revokeConsents, {
    mutationKey: MUTATION_KEYS.revokeConsents,
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
